import Image from 'next/image';
import { Trans } from 'next-i18next';
import React from 'react';
import { Text } from '@components/Text/Text.component';
import { PODCASTS_PARTNER_URL } from 'features/podcasts/business/podcasts.types';
import style from './PartnerSection.module.scss';

const PartnerSection = () => {
  return (
    <section className={style['partner-section']}>
      <div className="wrapper-s">
        <div>
          <Image
            alt="la-clé-des-champs"
            height={180}
            loading="eager"
            src="/img/podcasts/la-clé-des-champs.webp"
            unoptimized={true}
            width={180}
          />
        </div>

        <div>
          <Text flavour="light" variant="p">
            <Trans i18nKey="podcasts.partner.text" ns="podcasts">
              podcasts
              <a href={PODCASTS_PARTNER_URL} target="_blank">
                la clé des champs
              </a>
            </Trans>
          </Text>
        </div>
      </div>
    </section>
  );
};

export { PartnerSection };
